"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var common_1 = require("../../common");

var solver_1 = require("../../solver"); // Mark-level constraint


var ConstraintTypeClass =
/*#__PURE__*/
function () {
  function ConstraintTypeClass() {
    _classCallCheck(this, ConstraintTypeClass);
  }

  _createClass(ConstraintTypeClass, null, [{
    key: "register",
    value: function register(entry) {
      ConstraintTypeClass._classes.set(entry.type, entry);
    }
  }, {
    key: "getClass",
    value: function getClass(type) {
      return ConstraintTypeClass._classes.get(type);
    }
  }]);

  return ConstraintTypeClass;
}(); // Register and get mark class


ConstraintTypeClass._classes = new Map();
exports.ConstraintTypeClass = ConstraintTypeClass;

var SnapConstraintClass =
/*#__PURE__*/
function () {
  function SnapConstraintClass() {
    _classCallCheck(this, SnapConstraintClass);

    this.type = "snap";
  }

  _createClass(SnapConstraintClass, [{
    key: "buildConstraints",
    value: function buildConstraints(constraint, elements, states, solver) {
      var element = constraint.attributes.element;
      var attribute = constraint.attributes.attribute;
      var targetElement = constraint.attributes.targetElement;
      var targetAttribute = constraint.attributes.targetAttribute;
      var gap = constraint.attributes.gap;

      if (gap == null) {
        gap = 0;
      }

      var idxElement = common_1.getIndexById(elements, element);
      var idxTargetElement = common_1.getIndexById(elements, targetElement);
      var attr = solver.attr(states[idxElement].attributes, attribute);
      var targetAttr = solver.attr(states[idxTargetElement].attributes, targetAttribute);
      solver.addLinear(solver_1.ConstraintStrength.HARD, gap, [[1, attr], [-1, targetAttr]]);
    }
  }]);

  return SnapConstraintClass;
}();

exports.SnapConstraintClass = SnapConstraintClass;

function registerClasses() {
  ConstraintTypeClass.register(new SnapConstraintClass());
}

exports.registerClasses = registerClasses;